/* ProCosmo v3 product page — gallery + reveals (no dependency on the landing script) */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    /* gallery thumbnail switching */
    var main = document.getElementById("pdpMain");
    var thumbs = document.querySelectorAll(".pdp-thumb");
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var src = t.getAttribute("data-full");
        if (!src || !main) return;
        main.style.opacity = 0;
        setTimeout(function () { main.src = src; main.style.opacity = 1; }, 180);
        thumbs.forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });

    /* light scroll reveals */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll("[data-r]").forEach(function (el) { io.observe(el); });

    /* ---- Add to cart → open the theme's slide-out cart drawer ---- */
    function openDrawer(drawer) {
      if (!drawer) return;
      drawer.classList.remove("is-empty");
      if (typeof drawer.open === "function") drawer.open();
      else drawer.classList.add("animate", "active");
    }

    function addToCart(id, btn) {
      var drawer = document.querySelector("cart-drawer");
      var label = btn ? btn.querySelector("span") || btn : null;
      var prev = label ? label.textContent : "";
      if (label) label.textContent = "Adding…";
      if (btn) btn.disabled = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }], sections: "cart-drawer", sections_url: window.location.pathname })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (data) {
          var target = document.querySelector("#CartDrawer");
          if (drawer && data.sections && data.sections["cart-drawer"] && target) {
            var doc = new DOMParser().parseFromString(data.sections["cart-drawer"], "text/html");
            var fresh = doc.querySelector("#CartDrawer");
            if (fresh) target.innerHTML = fresh.innerHTML;
            openDrawer(drawer);
          } else {
            window.location = "/cart";
          }
        })
        .catch(function () { window.location = "/cart"; })
        .finally(function () { if (label) label.textContent = prev; if (btn) btn.disabled = false; });
    }

    var buyForm = document.getElementById("v3-buy-form");
    if (buyForm) {
      buyForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var idInput = buyForm.querySelector("[name=id]");
        if (idInput) addToCart(idInput.value, buyForm.querySelector('[type="submit"]'));
      });
    }

    /* ---- quantity change + remove inside the drawer (authoritative re-render) ---- */
    function reRenderDrawer(sectionHTML) {
      var target = document.querySelector("#CartDrawer");
      if (!sectionHTML || !target) return;
      var fresh = new DOMParser().parseFromString(sectionHTML, "text/html").querySelector("#CartDrawer");
      if (fresh) target.innerHTML = fresh.innerHTML;
      // lazy images injected via innerHTML don't auto-load — force them
      target.querySelectorAll("img[loading='lazy']").forEach(function (img) { img.loading = "eager"; });
    }
    function drawerChange(line, qty) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: Number(line), quantity: qty, sections: "cart-drawer", sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          reRenderDrawer(data.sections && data.sections["cart-drawer"]);
          var d = document.querySelector("cart-drawer");
          if (d) d.classList.toggle("is-empty", (data.item_count || 0) === 0);
        })
        .catch(function () {});
    }
    // Own the +/- buttons + remove entirely (capture phase, block the theme's handlers) — deterministic
    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      var btn = e.target.closest("#CartDrawer .quantity__button");
      if (btn) {
        e.preventDefault(); e.stopImmediatePropagation();
        var wrap = btn.closest(".quantity");
        var inp = wrap && wrap.querySelector(".quantity__input");
        if (!inp) return;
        var line = inp.getAttribute("data-index");
        var cur = parseInt(inp.value, 10) || 1;
        var next = btn.name === "plus" ? cur + 1 : Math.max(0, cur - 1);
        if (line) drawerChange(line, next);
        return;
      }
      var rm = e.target.closest("#CartDrawer cart-remove-button, #CartDrawer .cart-remove-button");
      if (rm) {
        e.preventDefault(); e.stopImmediatePropagation();
        var rline = rm.getAttribute("data-index") || (rm.querySelector("[data-index]") && rm.querySelector("[data-index]").getAttribute("data-index"));
        if (rline) drawerChange(rline, 0);
      }
    }, true);
    // manual typing in the quantity field
    document.addEventListener("change", function (e) {
      var inp = e.target;
      if (inp && inp.classList && inp.classList.contains("quantity__input") && inp.closest("#CartDrawer")) {
        var line2 = inp.getAttribute("data-index");
        var q = Math.max(0, parseInt(inp.value, 10) || 1);
        if (line2) drawerChange(line2, q);
      }
    });

    /* nav cart link opens the drawer too */
    var cartLink = document.querySelector(".v3-cartlink");
    if (cartLink) cartLink.addEventListener("click", function (e) {
      e.preventDefault();
      openDrawer(document.querySelector("cart-drawer"));
    });
  });
})();
